// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"431687889bce4638e2ee","678":"fabc8dd77a09e73bede7","883":"9f174f5db20727dd58b9"}[chunkId] + ".js";
};